module.exports = __webpack_public_path__ + "img/atalanta-logo-icon.feaecea2.png";